import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import translations from './translations'

const langDetection = i18n.use(LanguageDetector)

function getlanguage () {
  if (langDetection.language && langDetection.language.indexOf('el') > -1) {
    return 'el'
  }
  return (typeof localStorage !== 'undefined' && localStorage.getItem('i18nextLng')) || langDetection.language || 'en'
}

export default i18n
  // .use(LanguageDetector)
  .init({
    // we init with resources
    resources: {
      en: { tr: translations['en'] },
      el: { tr: translations['el'] },
    },
    lng: getlanguage(),
    fallbackLng: ['en'],

    // have a common namespace used around the full app
    ns: ['tr'],
    defaultNS: 'tr',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
    },

    react: {
      wait: true,
    },
  })



// WEBPACK FOOTER //
// ./src/i18n/index.js